<template>
  <div class="supply-dashboard">
    <span style="font-size: 10px; color: red;" v-if="errorMessage">
      {{ errorMessage }}
    </span>
    <div class="top-menu">
      <BaseInputLogic
        style="margin-bottom: 13px;"
        :options="menu.options"
        :value.sync="menu.value"
        @onDataChange="handleInputChange"
      ></BaseInputLogic>

      <b-form-checkbox
        v-model="isAutoRefreshEnabled"
        class="auto-refresh"
        switch
      >
        Atualização Automática
      </b-form-checkbox>
    </div>

    <div v-if="menu.value == '1'">
      <div class="filters">
        <SuspenseListFilter
          :title="filterTitles.plate"
          :options="supplyDashboardData.filterOptions.plate"
          :value="filters.plate"
          @update:value="value => onFilterUpdate('plate', value)"
        />
        <SuspenseListFilter
          :title="filterTitles.brand"
          :options="supplyDashboardData.filterOptions.brand"
          :value="filters.brand"
          @update:value="value => onFilterUpdate('brand', value)"
        />
        <SuspenseListFilter
          :title="filterTitles.model"
          :options="supplyDashboardData.filterOptions.model"
          :value="filters.model"
          @update:value="value => onFilterUpdate('model', value)"
        />
        <SuspenseListFilter
          :title="filterTitles.reviewType"
          :options="supplyDashboardData.filterOptions.reviewType"
          :value="filters.reviewType"
          @update:value="value => onFilterUpdate('reviewType', value)"
        />
        <b-form-group>
          <b-button
            size="sm"
            style="height: 40px; margin-top: 27px;"
            @click="clearFilters"
            class="btn btn-secondary mb-3 clear-filters"
          >
            Limpar Filtros
          </b-button>
        </b-form-group>
      </div>
      <div class="cards">
        <div style="grid-column: span 2;">
          <CardEChart
            :title="cardTitles.activeVehicles"
            :value="supplyDashboardData.cards.activeVehicles.value"
            :icon="cardIcons.whiteTruck"
          />
        </div>
      </div>
      <div class="pie">
        <PieEChart
          :title="chartTitles.revisionsStatus"
          :model="supplyDashboardData.charts.maintanceStatus"
          :preventive="true"
        />
      </div>
      <div class="charts">
        <div class="chart">
          <MaintanceTable
            :items="supplyDashboardData.tableData"
            :model="supplyDashboardData.tableData"
            :indiceValues="indiceValues"
            :preventive="true"
          />
        </div>
      </div>
    </div>
    <div v-if="menu.value == '2'">
      <div class="filters">
        <SuspenseListFilter
          :title="filterTitles.plate"
          :options="supplyDashboardData.filterOptions.plate"
          :value="filters.plate"
          @update:value="value => onFilterUpdate('plate', value)"
        />
        <SuspenseListFilter
          :title="filterTitles.status"
          :options="supplyDashboardData.filterOptions.status"
          :value="filters.status"
          @update:value="value => onFilterUpdate('status', value)"
        />
        <SuspenseListFilter
          :title="filterTitles.brand"
          :options="supplyDashboardData.filterOptions.brand"
          :value="filters.brand"
          @update:value="value => onFilterUpdate('brand', value)"
        />
        <SuspenseListFilter
          :title="filterTitles.model"
          :options="supplyDashboardData.filterOptions.model"
          :value="filters.model"
          @update:value="value => onFilterUpdate('model', value)"
        />
        <SuspenseListFilter
          :title="filterTitles.reviewTypeFilter"
          :options="supplyDashboardData.filterOptions.reviewTypeFilter"
          :value="filters.reviewTypeFilter"
          @update:value="value => onFilterUpdate('reviewTypeFilter', value)"
        />
        <DataRangeFilter
          :title="filterTitles.reviewDate"
          :defaultDate="false"
          :startDate.sync="filters.startReviewDate"
          :endDate.sync="filters.endReviewDate"
          @update:startDate="
            startDate => onFilterUpdate('startReviewDate', startDate)
          "
          @update:endDate="endDate => onFilterUpdate('endReviewDate', endDate)"
        />
        <b-form-group>
          <b-button
            size="sm"
            style="height: 40px; margin-top: 27px;"
            @click="clearFilters"
            class="btn btn-secondary mb-3 clear-filters"
          >
            Limpar Filtros
          </b-button>
        </b-form-group>
      </div>
      <div class="cards">
        <CardEChart
          :title="cardTitles.vehiclesAtMaintance"
          :value="supplyDashboardData.cards.vehiclesAtMaintance.value"
          :icon="cardIcons.whiteTruck"
        />
        <CardEChart
          :title="cardTitles.daysAtMaintance"
          :value="supplyDashboardData.cards.daysAtMaintance.value"
          :icon="cardIcons.yellowClock"
        />
        <CardEChart
          :title="cardTitles.totalValue"
          :value="supplyDashboardData.cards.totalValue.value"
          :icon="cardIcons.yellowGoal"
        />
      </div>
      <div class="charts chart-row">
        <PieEChart
          :title="chartTitles.maintanceTypeStatus"
          :model="supplyDashboardData.charts.maintenanceTypeStatus"
          :maintanceType="true"
        />
        <PieEChart
          :title="chartTitles.revisionsStatus"
          :model="supplyDashboardData.charts.maintanceStatus"
          :corrective="true"
        />
      </div>
      <div class="charts">
        <div class="chart">
          <MaintanceTable
            :items="supplyDashboardData.tableData"
            :model="supplyDashboardData.tableData"
            :corrective="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardEChart from "./Charts/CardEChart.vue";
import SuspenseListFilter from "./Charts/SuspenseListFilter.vue";
import TableChartComponent from "./Charts/TableChartComponent.vue";
import BaseInputLogic from "@/components_rms/base/BaseImputLogic.vue";
import PieEChart from "./Charts/PieEChart.vue";
import MaintanceTable from "./Charts/MaintanceTable.vue";
import DataRangeFilter from "./Charts/DataRangeFilter.vue";
import { debounce } from "throttle-debounce";

export default {
  name: "SupplyDashboard",
  components: {
    CardEChart,
    SuspenseListFilter,
    TableChartComponent,
    BaseInputLogic,
    PieEChart,
    MaintanceTable,
    DataRangeFilter
  },
  data() {
    return {
      isAutoRefreshEnabled: false,
      refreshInterval: null,
      errorMessage: null,
      supplyDashboardData: {
        cards: {
          activeVehicles: { value: 0 },
          daysAtMaintance: { value: 0 },
          vehiclesAtMaintance: { value: 0 },
          totalValue: { value: 0 }
        },
        charts: {
          maintanceStatus: [],
          maintanceTypeStatus: []
        },
        tableData: [],
        filterOptions: {
          plate: [],
          status: [],
          reviewType: [],
          brand: [],
          model: [],
          reviewTypeFilter: []
        }
      },
      cardTitles: {
        daysAtMaintance: "Total Dias em Manutenção",
        vehiclesAtMaintance: "Veículos em Manutenção",
        totalValue: "Valor Total",
        activeVehicles: "Veículos Ativos"
      },
      chartTitles: {
        revisionsStatus: "Status Manutenções",
        maintanceTypeStatus: "Tipos Manutenção"
      },
      filterTitles: {
        plate: "Placa",
        status: "Status",
        reviewType: "Tipo de Manutenção",
        brand: "Marca",
        model: "Modelo",
        reviewTypeFilter: "Tipo de Manutenção",
        reviewDate: "Periodo de Manutenção"
      },
      menu: {
        options: [
          { value: "1", text: "Preventivas" },
          { value: "2", text: "Histórico de Manutenções" }
        ],
        value: "1"
      },
      previousMenuValue: null,
      filters: {
        plate: "",
        status: "",
        reviewType: "",
        brand: "",
        model: "",
        reviewTypeFilter: "",
        startReviewDate: "",
        endReviewDate: ""
      },
      indiceValues: {
        kmGreen: 0,
        kmYellow: 0,
        kmRed: 0,
        daysGreen: 0,
        daysYellow: 0,
        daysRed: 0,
        horimeterGreen: 0,
        horimeterYellow: 0,
        horimeterRed: 0
      }
    };
  },
  watch: {
    isAutoRefreshEnabled(newValue) {
      if (newValue) {
        console.log("Auto refresh enabled");
        this.startAutoRefresh();
      } else {
        console.log("Auto refresh disabled");
        this.stopAutoRefresh();
      }
    }
  },
  computed: {
    cardIcons() {
      let whiteTruckSrc = "/img/yellow-truck-icon.png";
      let whiteMoneySrc = "/img/yellow-money-icon.png";
      let whiteFuelSrc = "/img/yellow-fuel-icon.png";
      let yellowClockSrc = "/img/yellow-clock-icon.png";
      let yellowGoalSrc = "/img/yellow-economy-icon.png";

      let blueTruckSrc = "/img/blue-truck-icon.png";
      let blueMoneySrc = "/img/blue-money-icon.png";
      let blueFuelSrc = "/img/blue-fuel-icon.png";
      let blueClockSrc = "/img/blue-clock-icon.png";
      let blueGoalSrc = "/img/blue-economy-icon.png";

      let whiteTruck, whiteMoney, whiteFuel, yellowClock, yellowGoal;

      if (!this.$store.state.darkmode) {
        whiteTruck = blueTruckSrc;
        whiteMoney = blueMoneySrc;
        whiteFuel = blueFuelSrc;
        yellowClock = blueClockSrc;
        yellowGoal = blueGoalSrc;
      } else {
        whiteTruck = whiteTruckSrc;
        whiteMoney = whiteMoneySrc;
        whiteFuel = whiteFuelSrc;
        yellowClock = yellowClockSrc;
        yellowGoal = yellowGoalSrc;
      }

      return {
        whiteTruck,
        whiteMoney,
        whiteFuel,
        yellowClock,
        yellowGoal
      };
    }
  },
  created() {
    // Definir a função debounced aqui
    this.debouncedLoadDashboardData = debounce(300, this.loadDashboardData);
  },
  mounted() {
    this.loadIndiceValues();
    this.getAllVehiclePlate();
    this.loadDashboardData();
  },
  methods: {
    startAutoRefresh() {
      this.refreshInterval = setInterval(() => {
        this.loadDashboardData();
      }, 300000);
    },
    stopAutoRefresh() {
      clearInterval(this.refreshInterval);
    },
    loadIndiceValues() {
      this.$apiVehicle.get("/GetRevisionsIndiceValues/").then(response => {
        this.indiceValues.kmGreen = response.data.kmGreen;
        this.indiceValues.kmYellow = response.data.kmYellow;
        this.indiceValues.kmRed = response.data.kmRed;
        this.indiceValues.daysGreen = response.data.daysGreen;
        this.indiceValues.daysYellow = response.data.daysYellow;
        this.indiceValues.daysRed = response.data.daysRed;
        this.indiceValues.horimeterGreen = response.data.horimeterGreen;
        this.indiceValues.horimeterYellow = response.data.horimeterYellow;
        this.indiceValues.horimeterRed = response.data.horimeterRed;
      });
    },
    onFilterUpdate(filterKey, newValue) {
      console.log(`Atualizando filtro: ${filterKey} para valor: ${newValue}`);
      this.filters[filterKey] = newValue;
      this.debouncedLoadDashboardData();
    },
    handleInputChange(newValue) {
      if (newValue !== null) {
        this.previousMenuValue = newValue;
        this.clearFilters();
        this.loadDashboardData();
      } else {
        this.menu.value = this.previousMenuValue;
      }
    },
    async getAllVehiclePlate() {
      try {
        const response = await this.$apiVehicle.get(
          "/vehicleRegistration/GetAllDropdown/"
        );
        this.supplyDashboardData.filterOptions.plate = response.data;
      } catch (error) {
        this.verifyExceptionType(error);
      }
    },
    async loadDashboardData() {
      if (this.menu.value == "1") {
        await this.fetchPreventiveDashboardData();
      } else if (this.menu.value == "2") {
        await this.fetchCorrectiveDashboardData();
      }
    },
    async fetchPreventiveDashboardData() {
      try {
        const params = {
          companyId: this.$store.state.companyId,
          plateFilter: this.filters.plate,
          brandFilter: this.filters.brand,
          modelFilter: this.filters.model,
          reviewType: this.filters.reviewType
        };
        const response = await this.$apiVehicle.get(
          `/GetPreventiveDashboardData`,
          { params }
        );
        this.supplyDashboardData = response.data;
        console.log("Dados Preventivos Recebidos:", this.supplyDashboardData);
      } catch (error) {
        this.verifyExceptionType(error);
      }
    },
    async fetchCorrectiveDashboardData() {
      try {
        const params = {
          companyId: this.$store.state.companyId,
          plateFilter: this.filters.plate,
          statusFilter: this.filters.status,
          brandFilter: this.filters.brand,
          modelFilter: this.filters.model,
          reviewTypeFilter: this.filters.reviewTypeFilter,
          startReviewDate: this.filters.startReviewDate,
          endReviewDate: this.filters.endReviewDate
        };
        const response = await this.$apiVehicle.get(
          `/GetCorrectiveDashboardData`,
          { params }
        );
        this.supplyDashboardData = response.data;
      } catch (error) {
        this.verifyExceptionType(error);
      }
    },
    verifyExceptionType(error) {
      if (error.response && error.response.status == 401) {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/login");
        });
      } else {
        this.errorMessage = error.message;
      }
    },
    clearFilters() {
      this.filters = {
        plate: "",
        status: "",
        reviewType: "",
        brand: "",
        model: "",
        reviewTypeFilter: "",
        startReviewDate: "",
        endReviewDate: ""
      };
      this.loadDashboardData();
    }
  }
};
</script>

<style scoped>
.supply-dashboard {
  width: 100%;
  padding: 5px;
  overflow: off;
}

.filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 5px;
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;
}

.full-width-card {
  grid-column: span 2;
}

.charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(700px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.chart {
  width: 100%;
}

.chart h3 {
  text-align: left;
}

.pie {
  margin-top: 10px;
}

.chart-row {
  display: flex;
  justify-content: space-between;
}

.top-menu {
  display: flex;
  gap: 10px;
}

.auto-refresh {
  margin-left: auto;
  align-items: center;
}

@media (max-width: 700px) {
  .clear-filters {
    width: 100%;
    display: block;
  }
  .pie {
    grid-row: auto;
    grid-column: span 1;
  }
  .charts {
    grid-template-columns: 1fr;
  }
  .chart {
    width: 100%;
    overflow-x: auto;
  }
  .chart-row {
    flex-direction: column;
    gap: 10px;
  }
  .cards {
    grid-template-columns: 1fr;
  }
  .top-menu {
    flex-direction: column;
  }
  .auto-refresh {
    display: none;
  }
  .full-width-card {
    grid-column: span 1;
  }
  .filters {
    flex-direction: column;
  }
  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .supply-dashboard {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
  }

  .charts,
  .cards {
    flex: 1;
    box-sizing: border-box;
  }
  .cards > *:last-child,
  .charts > *:last-child,
  .charts2 > *:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
</style>
